import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "ordered", "variant"];
import styled from 'styled-components';
import { View, Flex } from '../..';
import { ListContextProvider, useListContext } from './ListContext';
import { getListItemStyles, getListStyles } from './List.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledVerticalSeparator = styled.span.withConfig({
  displayName: "List__StyledVerticalSeparator",
  componentId: "sc-17zmzpg-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    inlineSize: '1px',
    blockSize: '1.1rem',
    backgroundColor: theme.color['border-default'],
    '&:first-child': {
      display: 'none'
    }
  };
});
export const ListItem = ({
  children,
  'data-test-id': dataTestId
}) => {
  const {
    variant
  } = useListContext();
  const listItemStyleProps = getListItemStyles(variant);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [variant === 'inline-divided' ? /*#__PURE__*/_jsx(StyledVerticalSeparator, {}) : null, /*#__PURE__*/_jsx(View, Object.assign({}, listItemStyleProps, {
      "data-test-id": dataTestId,
      as: "li",
      children: children
    }))]
  });
};
export const List = _ref => {
  let {
      children,
      ordered = false,
      variant = 'default'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const listElement = ordered ? 'ol' : 'ul';
  if (variant === 'inline' || variant === 'inline-divided') {
    return /*#__PURE__*/_jsx(ListContextProvider, {
      variant: variant,
      children: /*#__PURE__*/_jsx(Flex, Object.assign({}, rest, {
        as: listElement,
        display: "inline-flex",
        flexDirection: "row",
        columnGap: "200",
        alignItems: "center",
        children: children
      }))
    });
  }
  const listStyleProps = getListStyles(variant);
  return /*#__PURE__*/_jsx(ListContextProvider, {
    variant: variant,
    children: /*#__PURE__*/_jsx(View, Object.assign({}, rest, listStyleProps, {
      as: listElement,
      children: children
    }))
  });
};